import { TREASURY_AND_ACCOUNTING_URL } from "utils/constants";
import { ENDPOINTSTREASURYANDACCOUNTING } from "utils/endpoints";
import { http } from "utils/http";

export const getBank = async (
  pageNum,
  pageSize,
  searchString,
  orderBy,
  filterlist
) =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseInformationApi.Bank.brows,
    method: "get",
    params: {
      PageNumber: pageNum,
      PageSize: pageSize,
      OrderByString: orderBy,
      SearchString: searchString,
      FilterString: filterlist,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const getBankById = async (id) =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseInformationApi.Bank.load,
    method: "get",
    params: { Id: id },
    headers: { "Accept-Language": "en" },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const postBank = async (method, data) =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseInformationApi.Bank.brows,
    method: method,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const deleteBank = (id) =>
  http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseInformationApi.Bank.brows,
    method: "delete",
    params: {
      id: id,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
